import type { ReactNode } from 'react';

type TourListCardProps = {
    children: ReactNode;
    footer?: ReactNode;
    leading: ReactNode;
    trailing?: ReactNode;
    panelStyle?: 'default' | 'primary' | 'danger';
    shadow?: boolean;
    testId?: string;
    leadingWidth?: 60 | 70;
};

export const TourListCard = ({
    children,
    footer,
    leading,
    trailing,
    panelStyle = 'default',
    shadow = false,
    testId,
    leadingWidth = 70,
}: TourListCardProps) => (
    <div
        className={`panel panel-${panelStyle} margin-0 overflow-hidden width-100pct ${shadow ? 'shadow-subtle' : ''}`}
        data-testid={testId}
    >
        <div className='display-flex min-height-100pct'>
            <div
                className={`min-height-100pct display-grid place-items-center border border-right-only width-${leadingWidth} flex-0`}
            >
                {leading}
            </div>
            <div className='min-width-0 padding-15 flex-1-1-0 display-flex flex-column justify-content-center position-relative'>
                {children}
            </div>
            {trailing}
        </div>
        {footer}
    </div>
);
